import styled from 'styled-components';

export let ResetLink = styled.div`
    cursor: pointer;
`;

export let SelectContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
`;
